"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createAction = createAction;
Object.defineProperty(exports, "read", {
  enumerable: true,
  get: function () {
    return _request.read;
  }
});
Object.defineProperty(exports, "post", {
  enumerable: true,
  get: function () {
    return _request.post;
  }
});
Object.defineProperty(exports, "del", {
  enumerable: true,
  get: function () {
    return _request.del;
  }
});
Object.defineProperty(exports, "patch", {
  enumerable: true,
  get: function () {
    return _request.patch;
  }
});
Object.defineProperty(exports, "put", {
  enumerable: true,
  get: function () {
    return _request.put;
  }
});
exports.createSimpleAction = exports.useAction = exports.actionTypeCreator = void 0;

var _identity2 = _interopRequireDefault(require("lodash/fp/identity"));

var _redux = require("redux");

var _reactRedux = require("react-redux");

var _react = require("react");

var _request = require("./request");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __spreadArray = void 0 && (void 0).__spreadArray || function (to, from) {
  for (var i = 0, il = from.length, j = to.length; i < il; i++, j++) to[j] = from[i];

  return to;
};

var actionTypeCreator = function (prefix) {
  return function (actionName) {
    return "~" + prefix + "#" + actionName;
  };
};

exports.actionTypeCreator = actionTypeCreator;

var useAction = function (actionCreator, deps) {
  if (deps === void 0) {
    deps = [];
  }

  var dispatch = (0, _reactRedux.useDispatch)();
  return (0, _react.useMemo)(function () {
    return (0, _redux.bindActionCreators)(actionCreator, dispatch);
  }, __spreadArray([dispatch], deps));
};

exports.useAction = useAction;

var createSimpleAction = function (type) {
  return function () {
    return {
      type: type
    };
  };
};

exports.createSimpleAction = createSimpleAction;

function createAction(type, payloadCreator, metaCreator) {
  if (payloadCreator === void 0) {
    payloadCreator = _identity2.default;
  }

  if (metaCreator === void 0) {
    metaCreator = _identity2.default;
  }

  return function (params) {
    return {
      type: type,
      payload: payloadCreator(params),
      meta: metaCreator(params)
    };
  };
}